import { createAddressButtonStyles } from "@insite/content-library/Widgets/Addresses/CreateAddressButton";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

createAddressButtonStyles.createNewAddressButtonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    > div[class^="HiddenStyle"] {
                        > nav[class^="OverflowWrapper"] {
                            > button {
                                background: transparent !important;
                            }
                        }
                    }
                `,
                css`
                    > div[class^="HiddenStyle"] {
                        > nav[class^="OverflowWrapper"] {
                            > button {
                                background: transparent !important;
                            }
                        }
                    }
                `,
                null,
                null,
                null,
            ])};
        padding-right: 0;
    `,
};

createAddressButtonStyles.createNewAddressButton = {
    css:css`margin-right: 15px;`
};